import React, { useEffect, useState } from "react";
// import { Card, CardHeader, Container, Row } from "reactstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import { Table, Collapse } from "reactstrap";
import Classes from ".";
import statesModel from "models/states.model";
import { helper } from "lib/helper";
import axios from "axios";
import parentsModal from "models/parents.modal";
import tutorsModal from "models/tutors.modal";
import classModal from "models/class.modal";
import moment from "moment";

const label = { inputProps: { "aria-label": "Checkbox demo" } };
const EditClasses = () => {
  const params = useParams();
  const [classData, setClassData] = useState({});

  // add row in staudent and subject add multipal row
  const [rowData, setRowData] = useState([[]]);
  const addRow = () => {
    setRowData((prevData) => [...prevData, []]);
  };
  const deleteRow = (index) => {
    setRowData((prevData) => {
      const newData = [...prevData];
      newData.splice(index, 1);
      return newData;
    });
  };

  // all state get api
  const [stateList, setSatateList] = useState([]);
  const getListAllState = async () => {
    await statesModel
      .listState()
      .then((result) => {
        if (result) {
          setSatateList(result?.results);
        }
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
      });
  };
  useEffect(() => {
    getListAllState();
  }, []);

  // handleselect state  get id function
  const [selectedStateId, setSelectedStateId] = useState("");
  const [selectedName, setSelectedName] = useState("");
  const handleChange = (event) => {
    // Get the selected option
    const selectedOption = event.target.options[event.target.selectedIndex];
    // Update the state variables with the ID and name
    setSelectedStateId(selectedOption.value);
    getListAllCity(selectedOption.value || classData?.state);
    setSelectedName(selectedOption.text);
  };

  // all city get api in state id baises
  const [cityList, setCityList] = useState([]);
  const getListAllCity = async (id) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/studentapi/city/?state=${id}`
      );
      setCityList(response.data.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // parent list get in all parents get
  const [parentsList, setParentsList] = useState([]);
  const getListDataParents = async () => {
    await parentsModal
      .ParentlistallData()
      .then((result) => {
        if (result) {
          setParentsList(result?.data);
        }
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
      });
  };

  useEffect(() => {
    getListDataParents();
  }, []);

  // parent select function and get mobile no.
  const [selectedParentsId, setSelectedParentsId] = useState("");
  const handleChangeParents = (event) => {
    // Get the selected option
    const selectedOption = event.target.options[event.target.selectedIndex];
    // Update the state variables with the ID and name
    setSelectedParentsId(selectedOption.value);
    getListDataByidStudent(selectedOption.value);
  };

  // All tutors get api
  const [tutorsList, setTotursList] = useState([]);
  const getListDataTutors = async () => {
    await tutorsModal
      .tutorslistallData()
      .then((result) => {
        if (result) {
          setTotursList(result.data);
        }
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
      });
  };

  useEffect(() => {
    getListDataTutors();
  }, []);

  // tutors select function
  const [selectedTutorsId, setSelectedTutorsId] = useState("");
  const handleChangeTutors = (event) => {
    // Get the selected option
    const selectedOption = event.target.options[event.target.selectedIndex];
    // Update the state variables with the ID and name
    setSelectedTutorsId(selectedOption.value);
  };

  // classtype change function
  const [selectedClassType, setSelectedClassType] = useState(classData?.type);
  const handleChangeClassType = (event) => {
    // Get the selected option
    const selectedOption = event.target.options[event.target.selectedIndex];
    // Update the state variables with the ID and name
    setSelectedClassType(selectedOption.value);
  };

  // Parent id pass and parent student get
  const [studentList, setStatudentList] = useState([]);
  const getListDataByidStudent = (id) => {
    parentsModal
      .listbyParentidStudentGet(id)
      .then((response) => {
        console.log(response);
        setStatudentList(response.data.data);
      })
      .catch((error) => {});
  };

  // Student select function
  const handleStudentSelect = (e, index) => {
    const { value } = e.target;
    setRowData((prevData) => {
      const newData = [...prevData]; // Copy the previous state
      newData[index] = [parseInt(value)]; // Convert the selected value to a number and store it in the rowData array for the current row
      return newData; // Return the updated state
    });
  };

  // Subject select function
  const handleSubjectSelect = (e, rowIndex, subjectId) => {
    const { checked } = e.target;
    setRowData((prevData) => {
      const newData = [...prevData]; // Copy the previous state
      if (!newData[rowIndex]) {
        newData[rowIndex] = []; // Initialize the rowData array for the current row if it doesn't exist
      }
      const updatedRowData = [...newData[rowIndex]]; // Copy the rowData array for the current row
      const subjectIndex = updatedRowData.indexOf(subjectId);
      if (checked && subjectIndex === -1) {
        updatedRowData.push(subjectId); // Add the subjectId to the rowData array if it's checked and not already present
      } else if (!checked && subjectIndex !== -1) {
        updatedRowData.splice(subjectIndex, 1); // Remove the subjectId from the rowData array if it's unchecked and present
      }
      newData[rowIndex] = updatedRowData; // Update the rowData array for the current row in the newData array
      return newData; // Return the updated state
    });
  };

  // student id and subject id conbined one array
  const combinedArray = [];
  rowData.forEach((arr) => {
    combinedArray.push(arr);
  });

  // pass student id and get all subject in dstudent baises
  const [studentSubjectList, setStatudentSubjectList] = useState([]);
  const getListDataByidStudentSubject = () => {
    parentsModal
      .listbyParentidStudentSubjectGet(rowData[0])
      .then((response) => {
        console.log(response);
        setStatudentSubjectList(response.data.Subjects);
      })
      .catch((error) => {});
  };
  useEffect(() => {
    getListDataByidStudentSubject();
  }, [rowData]);

  // select start time function
  const [startTime, setStartTime] = useState("");
  console.log(startTime, "startTime");
  const handleStartTimeChange = (event) => {
    const { value } = event.target;
    setStartTime(value); // Update startTime state with the selected time
  };

  // select end time function
  const [endTime, setEndTime] = useState("");
  const handleEndTimeChange = (event) => {
    const { value } = event.target;
    setEndTime(value);
  };

  // select badge function
  const [badge, setBadge] = useState();
  const handleselectbadge = (event) => {
    const { value } = event.target;
    setBadge(value); // Update endTime state with the selected time
  };

  // select city function
  const [selectCityName, setSelectCityName] = useState("");
  const handleChangeCity = (event) => {
    const { value } = event.target;
    setSelectCityName(value);
  };

  // select status function
  const [selecttStatus, setSelectStatus] = useState("");
  const handleChangeStatus = (event) => {
    const { value } = event.target;
    setSelectStatus(value);
  };
  // select mode function
  const [selecttMode, setSelectMode] = useState("");
  const handleChangeMode = (event) => {
    const { value } = event.target;
    setSelectMode(value);
  };

  const [addsLoadig, setAddsLoadig] = useState(false);

  // class create  filed data in single state
  const [formData, setFormData] = useState({
    name: classData?.name,
    number_of_session: "",
    price_parent: "",
    price_tutor: "",
    margin: "",
    days: "",
    session_per_month: "",
    hours: "",
    duration: "",
    demo_link:classData?.demo_link
  });

  // input valu change in formdata
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value, // Store the value in the state
    }));
  };

  //  parents_price and tutors_price - nad show value in margin
  const calculateMargin = () => {
    const priceParent = parseFloat(formData.price_parent);
    const priceTutor = parseFloat(formData.price_tutor);
    if (!isNaN(priceParent) && !isNaN(priceTutor)) {
      // Check if both values are valid numbers
      return (priceParent - priceTutor).toString(); // Calculate and return the margin as a string
    }
    return ""; // Return an empty string if either value is not a valid number
  };

  // Calculate margin when either "Price Parent" or "Price Tutors" change
  useEffect(() => {
    const margin = calculateMargin();
    setFormData((prevState) => ({
      ...prevState,
      margin: margin,
    }));
  }, [formData.price_parent, formData.price_tutor]);

  const [meetingDate, setMeetingDate] = useState();
  const handleDateChange = (event) => {
    const { value } = event.target;
    setMeetingDate(value); // Update meetingDate state with the selected date
  };
  const formattedDate = moment(meetingDate).format("DD/MM/YYYY");

  useEffect(() => {
    if (classData?.start_date) {
      const formattedDate = moment(classData.start_date).format("DD/MM/YYYY");
      setMeetingDate(formattedDate);
    }
  }, [classData?.start_date]);

  const [selectedWeeks, setSelectedWeeks] = useState([]);
  const weekNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  useEffect(() => {
    // Simulating API data

    if (classData && classData?.days) {
      setSelectedWeeks(classData?.days);
    }
  }, [classData?.days]); // Empty dependency array to run the effect only once

  const handleCheckboxChange = (weekName) => {
    if (selectedWeeks.includes(weekName)) {
      setSelectedWeeks(selectedWeeks.filter((name) => name !== weekName));
    } else {
      setSelectedWeeks([...selectedWeeks, weekName]);
    }
  };

  // Class Create  post api
  const navigate = useNavigate();
  const handleSubmit = (event) => {
    setAddsLoadig(true);
    event.preventDefault();
    const data = {
      name: formData.name,
      state: selectedName,
      city: selectCityName,
      location: "Location Name",
      parent: parseInt(selectedParentsId),
      tutor: parseInt(selectedTutorsId),
      badge: parseInt(badge),
      type: selectedClassType,
      start_time: moment(startTime, "HH:mm").format("hh:mm A"),
      end_time: moment(endTime, "HH:mm").format("hh:mm A"),
      number_of_session: parseInt(formData.number_of_session),
      price_parent: parseInt(formData.price_parent),
      price_tutor: parseInt(formData.price_tutor),
      margin: parseInt(formData.margin),
      days: parseInt(formData.days),
      session_per_month: parseInt(formData.session_per_month),
      demo_link: formData.demo_link,
      start_date: formattedDate,
      days: selectedWeeks,
      hours: parseInt(formData.hours),
      duration: parseInt(formData.duration),
      students: combinedArray,
      mode: selecttMode,
      status: "Regular",
    };
    classModal
      .editClass(data)
      .then((response) => {
        // console.log(response.data, "fqAdd");
        helper.sweetalert.toast("Your class Create.", "success");
        navigate("/admin/classes");
        setAddsLoadig(false);
      })
      .catch((error) => {
        setAddsLoadig(false);
        // console.log(error);
      });
  };

  console.log(meetingDate, "meetingDate");

  const getListDataByid = () => {
    classModal
      .listbyClassid(params?.id)
      .then((response) => {
        setClassData(response.data.data);
        // console.log(response.data.data, "data");
      })
      .catch((error) => {
        // console.log(error);
      });
  };

  // console.log(parmas?.id, "params");
  useEffect(() => {
    if (params.id != "") {
      getListDataByid();
    }
  }, []);



  return (
    <>
      <Container className="pt-7">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader>
                <h3 className="mb-0">Edit Classes</h3>
              </CardHeader>
              <CardBody>
                <Form onSubmit={handleSubmit}>
                  <div>
                    <Row>
                      <Col md={2}>
                        <FormGroup>
                          {/* <Label for="state">State</Label> */}
                          <Input
                            id="state"
                            type="select"
                            onChange={handleChange}
                            required
                          >
                            <option>Select State</option>
                            {stateList &&
                              stateList?.map((item, index) => {
                                return (
                                  <option
                                    key={index}
                                    value={item.id}
                                    selected={classData?.state === item.name}
                                  >
                                    {item.name}
                                  </option>
                                );
                              })}
                          </Input>
                        </FormGroup>
                      </Col>

                      <Col md={2}>
                        <FormGroup>
                          {/* <Label for="exampleEmail">City</Label> */}
                          <Input
                            type="select"
                            onChange={handleChangeCity}
                            required
                          >
                            <option> Select City</option>
                            {cityList &&
                              cityList?.map((item, index) => {
                                return (
                                  <option
                                    value={item.name}
                                    selected={classData?.city === item.name}
                                  >
                                    {item?.name}
                                  </option>
                                );
                              })}
                          </Input>
                        </FormGroup>
                      </Col>

                      <Col md={2}>
                        <FormGroup>
                          {/* <Label for="exampleEmail">Location</Label> */}
                          <Input id="forType" type="select" required>
                            <option> Select Location</option>
                            <option value="1">Kolar</option>
                            <option value="2">Bhel</option>
                          </Input>
                        </FormGroup>
                      </Col>

                      <Col md={3}>
                        <FormGroup>
                          {/* <Label for="exampleEmail">Select Pairent</Label> */}
                          <Input
                            id="forType"
                            type="select"
                            onChange={handleChangeParents}
                            required
                          >
                            <option> Select Pairent </option>
                            {parentsList &&
                              parentsList?.map((item, index) => {
                                return (
                                  <option
                                    key={index}
                                    value={item.mobile}
                                    selected={
                                      classData?.parent ===
                                      item?.user.first_name
                                    }
                                  >
                                    {item?.user.first_name}{" "}
                                    {item?.user.last_name} ({item.mobile})
                                  </option>
                                );
                              })}
                          </Input>
                        </FormGroup>
                      </Col>

                      <Col md={3}>
                        <FormGroup>
                          {/* <Label for="exampleEmail">Select Badge</Label> */}
                          <Input
                            id="forType"
                            type="select"
                            onChange={handleselectbadge}
                            required
                          >
                            <option value="driver">Select Badge</option>
                            <option
                              value="1"
                              selected={classData?.badge === "1"}
                            >
                              1
                            </option>
                            <option
                              value="2"
                              selected={classData?.badge === "2"}
                            >
                              2
                            </option>
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={4}>
                        <FormGroup>
                          <Label for="exampleEmail">Class Name</Label>
                          <Input
                            type="text"
                            name="name"
                            placeholder="Enter Class Name"
                            value={formData.name || classData?.name}
                            onChange={handleInputChange}
                            required

                            // invalid
                          />
                        </FormGroup>
                      </Col>

                      <Col md={4}>
                        <FormGroup>
                          <Label for="exampleEmail">Tutor</Label>
                          <Input
                            id="forType"
                            type="select"
                            onChange={handleChangeTutors}
                            required
                          >
                            <option value="driver">Select Tutors</option>
                            {tutorsList &&
                              tutorsList?.map((item, index) => {
                                return (
                                  <option
                                    key={index}
                                    value={item.mobile}
                                    selected={
                                      classData?.tutor === item?.user.first_name
                                    }
                                  >
                                    {item?.user.first_name}{" "}
                                    {item?.user.last_name} ({item.mobile})
                                  </option>
                                );
                              })}
                          </Input>
                        </FormGroup>
                      </Col>

                      <Col md={4}>
                        <FormGroup>
                          <Label for="exampleEmail">Class Type</Label>
                          <Input
                            id="forType"
                            type="select"
                            onChange={handleChangeClassType}
                            required
                          >
                            <option value="">Select Class Type</option>
                            <option
                              value="Demo"
                              selected={classData?.type === "Demo"}
                            >
                              Demo
                            </option>
                            <option
                              value="RuningClass"
                              selected={classData?.type === "RuningClass"}
                            >
                              Runing Class
                            </option>
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="startTime">Class Start Time</Label>
                          <Input
                            style={{
                              border: "1px solid lightgrey",
                              padding: "6px 10px",
                              borderRadius: "6px",
                            }}
                            type="time"
                            id="startTime"
                            required
                            value={startTime || classData?.start_time} // Convert to 12-hour format
                            onChange={handleStartTimeChange} // Call handleStartTimeChange function when the time is changed
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="endTime">Class End Time</Label>
                          <Input
                            style={{
                              border: "1px solid lightgrey",
                              padding: "6px 10px",
                              borderRadius: "6px",
                            }}
                            type="time"
                            id="endTime"
                            required
                            value={endTime || classData?.end_time} // Convert to 12-hour format
                            onChange={handleEndTimeChange} // Call handleEndTimeChange function when the time is changed
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    {selectedClassType === "RuningClass" ||
                      (classData?.type === "RuningClass" && (
                        <>
                          <Row>
                            <Col md={3}>
                              <FormGroup>
                                <Label for="number_of_session">
                                  No. of Session
                                </Label>
                                <Input
                                  type="number"
                                  name="number_of_session"
                                  placeholder="Enter Amount"
                                  value={
                                    formData.number_of_session ||
                                    classData?.number_of_session
                                  }
                                  onChange={handleInputChange}
                                  required
                                  // defaultValue={}
                                />
                              </FormGroup>
                            </Col>
                            <Col md={3}>
                              <FormGroup>
                                <Label for="price_parent">Price Parent</Label>
                                <Input
                                  type="number"
                                  name="price_parent"
                                  placeholder="Enter Amount"
                                  value={
                                    formData.price_parent ||
                                    classData?.price_parent
                                  }
                                  onChange={handleInputChange}
                                  required
                                />
                              </FormGroup>
                            </Col>
                            <Col md={3}>
                              <FormGroup>
                                <Label for="price_tutor">Price Tutors</Label>
                                <Input
                                  type="number"
                                  name="price_tutor"
                                  placeholder="Enter Amount"
                                  value={
                                    formData.price_tutor ||
                                    classData?.price_tutor
                                  }
                                  onChange={handleInputChange}
                                  required
                                />
                              </FormGroup>
                            </Col>
                            <Col md={3}>
                              <FormGroup>
                                <Label for="margin">Margin</Label>
                                <Input
                                  type="text" // Use text type for margin to allow empty string
                                  name="margin"
                                  value={formData.margin || classData?.margin}
                                  readOnly // Make margin input readonly to prevent direct user input
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={4}>
                              <FormGroup>
                                <Label for="session_per_month">
                                  Session In A Month
                                </Label>
                                <Input
                                  type="number"
                                  name="session_per_month"
                                  placeholder="Enter Days"
                                  value={
                                    formData.session_per_month ||
                                    classData?.session_per_month
                                  }
                                  onChange={handleInputChange}
                                  required
                                />
                              </FormGroup>
                            </Col>
                            <Col md={4}>
                              <FormGroup>
                                <Label for="hours">Hours In A Month</Label>
                                <Input
                                  type="number"
                                  name="hours"
                                  placeholder="Enter Days"
                                  value={formData.hours || classData?.hours}
                                  onChange={handleInputChange}
                                  required
                                />
                              </FormGroup>
                            </Col>
                            <Col md={4}>
                              <FormGroup>
                                <Label for="duration">Class Duration</Label>
                                <Input
                                  type="number"
                                  name="duration"
                                  placeholder="Enter (1 hour/1.5 hours/or any other)"
                                  value={
                                    formData.duration || classData?.duration
                                  }
                                  onChange={handleInputChange}
                                  required
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </>
                      ))}
                    <Row>
                      {/* <Col md={6}>
                        <Label>status</Label>
                        <Input type="select" onChange={handleChangeStatus}>
                          <option value="">Select status</option>
                          <option value="online">online</option>
                          <option value="offline">offline </option>
                        </Input>
                      </Col> */}
                      <Col md={6}>
                        <Label>Mode</Label>

                        <Input
                          type="select"
                          onChange={handleChangeMode}
                          required
                        >
                          <option value="">Select mode</option>
                          <option
                            value="online"
                            selected={classData?.mode == "online"}
                          >
                            online
                          </option>
                          <option
                            value="offline"
                            selected={classData?.mode == "offline"}
                          >
                            offline{" "}
                          </option>
                        </Input>
                      </Col>
                      {selecttMode === "offline" ? null : selecttMode ===
                          "online" || classData?.mode == "online" ? (
                        <Col md={6}>
                          <Label>Demo Meet Link</Label>
                          <Input
                            type="text"
                            placeholder="Enter Demo Link"
                            required
                            name="demo_link"
                            value={formData.demo_link || classData.demo_link}
                            onChange={handleInputChange}
                          />
                        </Col>
                      ) : null}
                    </Row>

                    {rowData.map((row, index) => (
                      <div key={index}>
                        <Row className="mt-3">
                          <Col md={12}>
                            {index !== 0 && (
                              <i
                                className="fa-solid fa-xmark"
                                color="danger"
                                onClick={() => deleteRow(index)}
                                style={{
                                  float: "right",
                                  fontSize: "20px",
                                  color: "red",
                                  marginBottom: "20px",
                                }}
                              />
                            )}
                          </Col>
                        </Row>
                        <Row>
                          <Col md={12}>
                            <Label for={`studentSelect${index}`}>Student</Label>
                            <Input
                              id={`studentSelect${index}`}
                              type="select"
                              onChange={(e) => handleStudentSelect(e, index)}
                              required
                              value={parseInt(row[0])} // Convert the selected value to a number using parseInt
                            >
                              <option value="">Select Student</option>
                              {studentList &&
                                studentList.map((item, itemIndex) => (
                                  <option key={itemIndex} value={item.id}>
                                    {item?.name}
                                  </option>
                                ))}
                            </Input>
                          </Col>
                        </Row>
                        <Row className="mt-3 ml-2">
                          <Col md={12}>
                            {studentSubjectList &&
                              studentSubjectList.map(
                                (subjectGroup, subjectIndex) => {
                                  return (
                                    <div key={subjectIndex}>
                                      <Input
                                        type="checkbox"
                                        value={subjectGroup?.id}
                                        onChange={(e) =>
                                          handleSubjectSelect(
                                            e,
                                            index,
                                            subjectGroup.id
                                          )
                                        }
                                        checked={row.includes(subjectGroup.id)} // Check if subjectGroup.id is in the current row's data
                                        required
                                      />
                                      {subjectGroup.data.map(
                                        (subject, dataIndex) => (
                                          <span
                                            key={dataIndex}
                                            style={{
                                              fontSize: "14px",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {dataIndex !== 0 && " / "}
                                            {subject.name}
                                          </span>
                                        )
                                      )}
                                      <br />
                                    </div>
                                  );
                                }
                              )}
                          </Col>
                        </Row>
                      </div>
                    ))}

                    {/* <button onClick={saveToDatabase}>Save to Database</button> */}
                    <Row>
                      <Col md={12} style={{ fontSize: "20px", float: "right" }}>
                        <i
                          className="fa-solid fa-plus"
                          onClick={addRow}
                          style={{
                            float: "right",
                            fontSize: "20px",
                            color: "blue",
                          }}
                        ></i>{" "}
                        {/* Plus icon to add rows */}
                      </Col>
                    </Row>

                    <Row>
                      <Col md={4}>
                        {" "}
                        <FormGroup>
                          <Label for="meetingDate">
                            {" "}
                            {selectedClassType === "RuningClass"
                              ? "Class Start Date"
                              : selectedClassType === "Demo"
                              ? "Demo Date"
                              : "Date"}
                          </Label>
                          <Input
                            style={{
                              border: "1px solid lightgrey",
                              padding: "6px 10px",
                              borderRadius: "6px",
                            }}
                            type="date"
                            id="meetingDate"
                            // name="interview_date"
                            placeholder="Select  date"
                            defaultValue={moment(classData?.start_date).format("YYYY/MM/DD")}
                            // value={meetingDate ||  } // Set the value of the input field to the meetingDate state
                            onChange={handleDateChange} // Call handleDateChange function when the date is changed
                          />
                        </FormGroup>
                      </Col>
                      {selectedClassType === "RuningClass" ||
                        (classData?.type === "RuningClass" && (
                          <Col md={8}>
                            <span>Select Week Days</span>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                              }}
                            >
                              {/* Render each week name with its checkbox */}
                              {weekNames.map((weekName, index) => (
                                <div key={index} style={{ marginTop: "10px" }}>
                                  <label htmlFor={weekName}>{weekName}</label>
                                  <div
                                  // style={{
                                  //   display: "flex",
                                  //   flexDirection: "row",
                                  // }}
                                  >
                                    <input
                                      type="checkbox"
                                      id={weekName}
                                      checked={selectedWeeks.includes(weekName)}
                                      onChange={() =>
                                        handleCheckboxChange(weekName)
                                      }
                                      style={{
                                        width: "25px",
                                        height: "20px",
                                        marginLeft: "1px",
                                      }}
                                    />
                                  </div>
                                </div>
                              ))}
                              {/* <h3>
                                Selected Week Days: {selectedWeeks.join(", ")}
                              </h3> */}
                            </div>
                          </Col>
                        ))}
                    </Row>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: "8px",
                      flexDirection: "row",
                    }}
                  >
                    <Button to="/admin/classes" color="danger" tag={Link}>
                      Cancel
                    </Button>
                    {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
                    <Button
                      color="primary"
                      type="submit"
                      style={{ float: "right", marginLeft: "5%",backgroundColor:"#080278",color:"white",border:"none"}}
                    >
                      Save
                    </Button>
                    {/* )} */}
                  </div>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default EditClasses;
